import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';

export {default as App} from './components/App';

export default {actions, reducer, selectors};
